import React, { useEffect, useState } from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import LoginPage from "./components/Login/LoginPage";
import Footer from "./components/pages/Footer";
import Header from "./components/pages/Header";
import WhyEPPSection from "./components/pages/dashboard/WhyEPPSection";
import HeroSection from "./components/pages/dashboard/HeroSection";
import TermsAndCondition from "./components/termsAndConditions/TermsAndCondition";
import PrivacyPolicy from "./components/termsAndConditions/PrivacyPolicy";
import CancellationAndRefund from "./components/termsAndConditions/CancellationAndRefund";
import TraitsSection from "./components/pages/dashboard/TraitsSection";
import HowItWorksSection from "./components/pages/HowItWorksSection";
import ScienceSection from "./components/pages/dashboard/ScienceSection";
import CTASection from "./components/pages/CTASection";
import AboutUsPage from "./components/aboutUS/AboutUsPage";
import TrustedBySection from "./components/pages/TrustedBySection";
import JobPostSection from "./components/pages/JobPostSection";
import UniqueSelfSync from "./components/pages/UniqueSelfsync";
import Scheduler from "./components/pages/Scheduler";
import FreeTrial from "./components/pages/FreeTrial";
import ComingSoon from "./components/pages/commingSoon/ComingSoon";
import PricingPlans from "./components/pages/subscription/Pricing";
import ContactUs from "./components/pages/ContactUS/ContactUsPage";
import Signup from "./components/Login/Signup";
import FAQHelpCenter from "./components/pages/FAQPage";
import CookieBanner from "./components/banner/CookieBanner";
import HiringStats from "./components/pages/HiringStats";
import HowToUse from "./components/pages/howItWorks/howItWorks";
import HiringNewCandidate from "./components/pages/dashboard/HiringNewCandidate";
import WhyItWorks from "./components/pages/dashboard/WhyItWorks";
import SalesData from "./components/pages/Sales/SalesData";
import ThankYou from "./components/ui/ThankYouPage";
import DashBoard from "./components/pages/dashboard/DashBoard";
import ViewReport from "./components/Login/SmapleReport/SmapleReport";
import Blogs from "./components/pages/Blogs/Blogs";
import BlogId from "./components/pages/Blogs/BlogId";
import PartnerPage from "./components/partnerPage/PartnerPage";
import ThankYouPage from "./components/partnerPage/ThankYouPage";
import StudentLandingPage from "./components/common/StudentLandingPage";

function App() {
  const location = useLocation();
  const hideFooterRoutes = ["/student-landing-page"];


  return (
    <div className="overflow-hidden">
      <Header />
      <Routes>
     
        {/* <Route
          path="/"
          element={
            <>
              <HeroSection />
              <WhyEPPSection />
              <HiringNewCandidate />
              <WhyItWorks />
              <HiringStats />
              <HowItWorksSection />
              <TraitsSection />
              <ScienceSection />
              <TrustedBySection />
              <CTASection />
            </>
          }
        /> */}

        <Route
          path="/"
          element={
            <>
              <DashBoard />
            </>
          }
        />

        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/book-demo" element={<Scheduler />} />
        <Route path="/schedule-demo" element={<FreeTrial />} />
        {/* <Route path="/comming-soon" element={<ComingSoon />} /> */}
        {/* Pricing  */}
        <Route path="/pricing" element={<PricingPlans />} />
        {/* terms and conditions pages  */}
        <Route path="/terms-of-service" element={<TermsAndCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/cancellation-refund"
          element={<CancellationAndRefund />}
        />
        <Route path="/faq" element={<FAQHelpCenter />} />
        <Route path="/how-it-works" element={<HowToUse />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<BlogId />} />
        <Route path="/partner-with-us" element={<PartnerPage />} />
        {/* Contact us page */}
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/sample-report" element={<ViewReport />} />
        <Route path="/partner-with-us/thank-you" element={<ThankYouPage />} />
        <Route path="/student-placement-cell" element={<StudentLandingPage/>}/>
        <Route path="/student-placement-cell/thank-you" element={<ThankYouPage/>}/>
      </Routes>
      
       <Footer/>
      <CookieBanner />
    </div>
  );
}

export default App;
